/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { usePathname, useSearchParams } from 'next/navigation'

export type FilterNameType =
  | 'brands'
  | 'retailers'
  | 'categories'
  | 'discount'
  | 'price'
  | 'sortBy'
  | 'buyNowOnly'

export const useGetRedirectPath = () => {
  const selectedBrands = useSearchParams().get('brands')?.split(',') ?? []
  const selectedRetailers = useSearchParams().get('retailers')?.split(',') ?? []
  const selectedDiscount = useSearchParams().get('discount')?.split(',') ?? []
  const selectedPrice = useSearchParams().get('price')?.split(',') ?? []
  const selectedCategories =
    useSearchParams().get('categories')?.split(',') ?? []
  const origin = usePathname()

  const getRedirectPath = (
    updatedFilters: string[],
    filterName: FilterNameType,
  ): string => {
    const queryParamFilters: {
      brands?: string[]
      retailers?: string[]
      categories?: string[]
      discount?: string[]
      price?: string[]
      buyNowOnly?: string
      sortBy?: string
    } = {}
    if (selectedBrands.length > 0) {
      queryParamFilters.brands = selectedBrands
    }
    if (selectedRetailers.length > 0) {
      queryParamFilters.retailers = selectedRetailers
    }
    if (selectedCategories.length > 0) {
      queryParamFilters.categories = selectedCategories
    }
    if (selectedDiscount.length > 0) {
      queryParamFilters.discount = selectedDiscount
    }
    if (selectedPrice.length > 0) {
      queryParamFilters.price = selectedPrice
    }

    if (updatedFilters.length > 0) {
      return `${origin}?${new URLSearchParams({
        ...queryParamFilters,
        [filterName]: updatedFilters,
        page: '1', // reset to first page on change
      } as unknown as URLSearchParams).toString()}`
    }
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    const { [filterName]: _, ...newFilters } = queryParamFilters

    return `${origin}?${new URLSearchParams(
      newFilters as URLSearchParams,
    ).toString()}`
  }
  return { getRedirectPath }
}
